import React, { useState, useEffect } from 'react';
import axios from "axios";
import css from "./ETFs.css";
import { getLan } from "../../stores/utils/utilities";
import { IntlProvider, defineMessages, FormattedMessage } from "react-intl";

import LogoETFs from "../../assets/images/BIVAETF.png";
import MarketOverviewWidget from "../../components/ui/tradingviewWidget/MarketOverviewWidget";
import TickerTapeWidget from "../../components/ui/tradingviewWidget/TickerTapeWidget";
import MarketDataWidget from "../../components/ui/tradingviewWidget/MarketDataWidget";
import HeatMapETFWidget from "../../components/ui/tradingviewWidget/HeatMapETFWidget";
import TopStoriesWidget from "../../components/ui/tradingviewWidget/TopStoriesWidget";
import VideoPlayerPaged from "../../components/videos/VideoPlayerPaged";

import NuevosListados from "./NuevosListados";
import TarjetasEducativas from "./TarjetasEducativas";
import Eventos from "./Eventos";

const lang = getLan();
const videoKeyword = "ETFs";
const defaultVideoId = "Lij7oUkiZuY";
const dominio = process.env.REACT_APP_DOMINIO;
//Tickers a mostrar en widgets. Obtener de un servicio
const marketOverviewSymbols = [{"s":"BIVA:VMEX/19"},{"s":"BIVA:PSOTRAC/15"},{"s":"BIVA:DLRTRAC/15"},{"s":"BIVA:VOO"},
  {"s":"BIVA:SPY"}];
const marketDataSymbolsGroups = [{"name":"ETFs",
  "symbols":[{"name":"BIVA:VMEX/19", "displayName": "VANGUARD FTSE BIVA MEXICO EQUITY ETF"},
    {"name":"BIVA:PSOTRAC/15", "displayName": "ÍNDICE BMV USD-MXP"},
    {"name":"BIVA:DLRTRAC/15", "displayName": "ÍNDICE BMV MXP-USD"},
    {"name":"BIVA:ESGMEX/ISHRS", "displayName": "ESGMEX-TRAC"},
    {"name":"BIVA:GENIUS/21", "displayName": "Genius"},
    {"name":"BIVA:VOO", "displayName": "VANGUARD S&P 500 ETF"},
    {"name":"BIVA:SPY", "displayName": "SPDR S&P 500 ETF TRUST"},
    {"name":"BIVA:IVV", "displayName": "ISHARES CORE S&P 500 ETF"},
    {"name":"BIVA:VTI", "displayName": "VANGUARD TOTAL STOCK MARKET ETF"},
    {"name":"BIVA:QQQ", "displayName": "INVESCO QQQ TRUST"}]
}];
const tickerTapeSymbols = [{"proName":"BIVA:VMEX/19"},{"proName":"BIVA:PSOTRAC/15"},{"proName":"BIVA:DLRTRAC/15"},
  {"proName":"BIVA:VOO"},{"proName":"BIVA:SPY"}];

function ETFs() {
  let [textos, setTextos] = useState({});

  useEffect(() => {
    let url = `${dominio}/cms/o/text/page/109/lang/${lang}`;
    axios.get(url)
      .then(response => {
        setTextos(defineMessages(response.data));
      })
      .catch(err => console.log(err));
  }, []);

  return (
    <IntlProvider locale={lang} messages={textos} onError={() => {}}>
      <div className="row">

        <div className="col-12 sin_padding">
          <div className="col-12 margen_top_30">
            <img src={LogoETFs} alt="etfs" className={css.logoETFs} />
          </div>
          <div className={["col-12", css.fondo, css.topAndBottomDivider, css.tickerTape].join(" ")}>
            <TickerTapeWidget locale={lang} displayMode="compact" symbols={tickerTapeSymbols} />
          </div>
        </div>

        <div className={`col-12 ${css.contenido_principal}`}>
          <div className="row col-12 margen_top_20">
            <div className={[css.fondo, css.rightDivider, "col-lg-8 col-md-12 col-sm-12 col-xs-12"].join(" ")}>
              <h1 className={css.title}><FormattedMessage id="etfs.videos.titulo" defaultMessage="Videos Relevantes" /></h1>
              <VideoPlayerPaged videoKeyword={videoKeyword} defaultVideoId={defaultVideoId} videosPerPage={3}/>
            </div>
            <div className={[css.fondo, "col-lg-4 col-md-12 col-sm-12 col-xs-12"].join(" ")} >
              <h1 className={css.title}><FormattedMessage id="etfs.top.titulo" defaultMessage="Top ETFs" /></h1>
              <MarketOverviewWidget title="ETFs" widgetStyle={css.marketOverviewWidget}  symbols={marketOverviewSymbols} locale={lang} hideTVFooter={true}/>
            </div>
          </div>

          <div className={[css.bottomDivider, "row col-12 margen_top_10 margen_abajo"].join(" ")}></div>

          <div className="row col-12">
            <div className={[css.fondo, css.rightDivider, css.nuevosListados, "col-lg-6 col-md-12 col-sm-12 col-xs-12"].join(" ")}>
              <h1 className={css.title}><FormattedMessage id="etfs.nuevosListados.titulo" defaultMessage="Nuevos Listados" /></h1>
              <NuevosListados lang={lang} />
            </div>
            <div className={[css.fondo, "col-lg-6 col-md-12 col-sm-12 col-xs-12"].join(" ")} >
              <h1 className={css.title}><FormattedMessage id="etfs.eventos.titulo" defaultMessage="Eventos" /></h1>
              <Eventos lang={lang} />
            </div>
          </div>

          <div className={[css.bottomDivider, "row col-12 margen_top_10 margen_abajo"].join(" ")}></div>

          <div className="row col-12">
            <div className={[css.fondo, "col-12 "].join(" ")}>
              <h1 className={css.title}><FormattedMessage id="etfs.monitor.titulo" defaultMessage="Monitor ETFs" /></h1>
              <MarketDataWidget widgetStyle={css.marketDataWidget} symbolsGroups={marketDataSymbolsGroups} locale={lang}/>
            </div>
          </div>

          <div className={[css.bottomDivider, "row col-12 margen_top_10 margen_abajo"].join(" ")}></div>

          <div className="row col-12">
            <div className={[css.fondo, "col-12 "].join(" ")}>
              <h1 className={[css.title, "col-12 row"].join(" ")}><FormattedMessage id="etfs.educacional.titulo" defaultMessage="Sección Educativa" /></h1>
              <TarjetasEducativas lang={lang} />
            </div>
          </div>

          <div className={[css.bottomDivider, "row col-12 margen_top_10 margen_abajo"].join(" ")}></div>

          <div className="row col-12">
            <div className={[css.fondo, "col-12 row"].join(" ")}>
              <h1 className={[css.title, "col-12 row"].join(" ")}><FormattedMessage id="etfs.mapaDeCalor.titulo" defaultMessage="Mapa de calor ETFs" /></h1>
              <HeatMapETFWidget style={css.heatMapETFWidget} locale={lang}/>
            </div>
          </div>

          <div className={[css.bottomDivider, "row col-12 margen_top_10 margen_abajo"].join(" ")}></div>

          <div className="row col-12">
            <div className={[css.fondo, "col-12 row"].join(" ")}>
              <TopStoriesWidget style={css.topStoriesWidget}/>
            </div>
          </div>
        </div>

        <div className="col-12 padding_bottom_100">
          {
            //Footer
          }
        </div>
      </div>
    </IntlProvider>
  );
}

export default ETFs;
